<input hidden="true" multiple="true" accept="image/png,image/jpeg" type="file" #fileImagesElement
  (change)="onLoaded($event)">

<app-ml-web-cam (onTakeSnapshot)="takeSnapshot($event)" [title]="label + ' (' + items.length +')'" [hidden]="!webcam.cameraOn" #webcam></app-ml-web-cam>

<mat-card *ngIf="!webcam.cameraOn" class="label-card">
  <mat-card-header>
    <mat-card-title class="card-title"><i>{{ label }} ({{items.length}})</i></mat-card-title>
  </mat-card-header>

  <mat-card-content class="scrollable-content">

    <mat-action-list *ngIf="labeledDataManager.modelType == 'text'" dense>
      <mat-list-item *ngFor="let item of items | reverse" (click)="delete(item)" matTooltip="{{item}}">
        <p class="text-item" matline>
          {{item}}
        </p>
      </mat-list-item>
    </mat-action-list>


    <mat-action-list *ngIf="labeledDataManager.modelType == 'numerical'" dense>
      <mat-list-item *ngFor="let item of items | reverse" (click)="delete(item)" matTooltip="{{item}}">
        <p class="text-item" matline>
          {{item}}
        </p>
      </mat-list-item>
    </mat-action-list>

    <mat-grid-list *ngIf="labeledDataManager.modelType == 'image'" cols="4" rowHeight="100px">
      <mat-grid-tile *ngFor="let item of items | reverse" (click)="delete(item)">
        <img height="100px" [src]="item.src">
      </mat-grid-tile>
    </mat-grid-list>

  </mat-card-content>
  <mat-card-actions>
    <button *ngIf="labeledDataManager.modelType == 'text'" mat-button (click)="addTerm()"
    matTooltip="{{'label-container.addtext.hint' | translate}}">
      <mat-icon>add_circle</mat-icon>
    </button>


    <button *ngIf="labeledDataManager.modelType == 'numerical'" mat-button (click)="addNumericalInput()"
    matTooltip="{{'label-container.addnumericalinput.hint' | translate}}">
      <mat-icon>add_circle</mat-icon>
    </button>

    <button *ngIf="labeledDataManager.modelType == 'image'" mat-button (click)="addImages()"
      matTooltip="{{'label-container.addimage' | translate}}">
      <mat-icon>add_photo_alternate</mat-icon>
    </button>
    <button *ngIf="labeledDataManager.modelType == 'image'" mat-button
      (click)="initWebcam()" matTooltip="{{'label-container.addwebcam' | translate}}">
      <mat-icon>add_a_photo</mat-icon>
    </button>
    <button  mat-button (click)="deleteLabel()" matTooltip="{{'label-container.deletelabel' | translate}}">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-card-actions>

</mat-card>
